<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>
        <BuyoutTabs></BuyoutTabs>
        <AlphabetScroll :alphabet="alphabet" :context="this" :scrollPos="scrollPos"></AlphabetScroll>
        <div class="offer-scroll" v-scroll-spy="scrollPos">
            <div class="letter-block" v-for="letter in alphabet" :id="`letter-${letter.letter}`">
                <StatisticTable v-for="row in rows[letter.letter]" :title="`${Helper.getOfferTitle(offers, row.id)} ${Storage.developMode ? `(${row.id})` : ''}`"
                                :headColumns="headColumns"
                                :footColumns="footColumns[row.id]" :rows="row.cells" :key="row.id"
                                v-if="Helper.getOfferTitle(offers, row.id)">
                </StatisticTable>
            </div>
        </div>
    </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'
  import API from '@/api/API'
  import Storage from '@/api/Storage'
  import { map, orderBy, findIndex } from 'lodash'
  import Helper from '@/api/Helper'
  import TypeColor from '@/assets/TypeColor'
  import StatisticTable from '@/components/StatisticTable.vue'
  import BuyoutTabs from './BuyoutTabs.vue'
  import AlphabetScroll from '@/components/AlbhabetScroll.vue'
  import getSymbolFromCurrency from 'currency-symbol-map'

export default {
    name: 'Offer',
    components: {
      Filters,
      StatisticTable,
      BuyoutTabs,
      AlphabetScroll
    },
    data () {
      return {
        scrollPos: 0,
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          courierFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        headColumns: [
          {label: this.$root.$t('statistic.courier'), field: 'courier'},
          {label: this.$root.$t('statistic.shipped'), field: 'shipped'},
          {label: this.$root.$t('statistic.delivered'), field: 'delivered'},
          {label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
          {label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2},
          {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2}
        ],
        rows: [],
        footColumns: [],
        offers: [],
        alphabet: []
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    ready: function () {
      this.$scrollSet()
    },
    methods: {
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = {}
        this.footColumns = []
        this.alphabet = []
        this.offers = Storage.offers.slice(0)
        let oldArrCurrency = []
        let newArrCurrency = []
        API.getBuyoutStatistic().then(response => {
          let statistic = {}
          map(response.data, d => {
            oldArrCurrency.push(d.local_currency.split(','))
            oldArrCurrency.forEach(array => {
              array.forEach(item => {
                newArrCurrency.push(item)
              })
            })
          })
          let filterCurrency = newArrCurrency.filter((item, index) => {
            return newArrCurrency.indexOf(item) === index
          })
          map(response.body, d => {
            if (!statistic[d.offer_id]) {
              statistic[d.offer_id] = []
            }
            statistic[d.offer_id].push(d)
          })
          const sortedResponse = orderBy(statistic, [function (i) {
            const title = Helper.getOfferTitle(Storage.offers, i[0].offer_id)
            return !title ? 'A' : title
          }], ['asc'])
          map(sortedResponse, (offer, i) => {
            const offerId = offer[0].offer_id
            if (Helper.getOfferTitle(Storage.offers, offerId)[0]) {
              let totalShipped = 0
              let totalReturn = 0
              let totalPaid = 0
              let countReturn = 0
              let totalTransit = 0
              let countTransit = 0
              let totalDelivered = 0
              let sumAverageBill = 0.0
              let sumTransit = 0
              let sumAverageBillLocal = 0.0
              const letter = Helper.getOfferTitle(Storage.offers, offerId)[0].toUpperCase()
              const letterIndex = findIndex(this.alphabet, {letter: letter})
              if (letterIndex === -1) {
                this.alphabet.push({
                  id: offerId,
                  letter: letter,
                  count: 1
                })
                this.rows[letter] = []
                i = 0
              } else {
                this.alphabet[letterIndex].count++
                i = this.rows[letter].length
              }
              this.rows[letter][i] = {
                id: offerId,
                cells: []
              }
              map(offer, (d) => {
                this.rows[letter][i].cells.push({
                  courier: {
                    value: `${Helper.getCourierTitle(Storage.couriers, d.courier_id)} ${Storage.developMode ? `(${d.courier_id})` : ''}`,
                    style: {textAlign: 'left'}
                  },
                  shipped: {
                    value: d.shipped,
                    bg: true
                  },
                  delivered: {
                    value: d.delivered,
                    bg: true
                  },
                  transit: {
                    value: d.shipped - d.delivered - d.return,
                    bgg: Helper.renderGistPart(d.shipped, d.shipped - d.delivered - d.return),
                    isCollspaned: true
                  },
                  transitPercents: {
                    value: Helper.percents(d.shipped, d.shipped - d.delivered - d.return),
                    bgg: Helper.renderGistPart(d.shipped, d.shipped - d.delivered - d.return, true)
                  },
                  return: {
                    value: d.return,
                    bgg: Helper.renderGistPart(d.shipped, d.return),
                    isCollspaned: true
                  },
                  returnPercents: {
                    value: Helper.percents(d.shipped, d.return),
                    bgg: Helper.renderGistPart(d.shipped, d.return, true)
                  },
                  buyout: {
                    colspan: 2,
                    value: Helper.percents(d.shipped, d.delivered),
                    dbgg: [
                        {name: 'delivered', width: parseFloat(Helper.percents(d.shipped, d.delivered - d.paid))},
                        {name: 'buyout', width: parseFloat(Helper.percents(d.shipped, d.paid))}
                    ],
                    htmlValue: `<p style="display: inline; float: left; margin-left: 5px; margin-bottom: 0;">${Helper.percents(d.shipped, d.delivered - d.paid)} ${Storage.developMode ? `(${d.delivered - d.paid})` : ''}</p> <p style="display: inline; float: right; margin-right: 5px; margin-bottom: 0;">${Helper.percents(d.shipped, d.delivered)} ${Storage.developMode ? `(${d.paid})` : ''}</p></div>`
                  },
                  averageBill: {
                    value: d.approved > 0 ? '$ ' + (d.total_bill_usd / d.approved).toFixed(2) : '$ 0.0'
                      // bgg: Helper.renderSingleGist(100, Helper.averageBill(d.average_bill, false, true))
                  },
                  averageBillLocal: {
                    value: d.local_currency.split(',').length === 1 && d.approved > 0 ? `${(d.total_bill_local / d.approved).toFixed(0)} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                      // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, true), true)
                  }
                })
                totalShipped += d.shipped
                totalDelivered += d.delivered
                if (d.return > 0) {
                  totalReturn += d.return
                  countReturn++
                }
                if (d.paid > 0) {
                  totalPaid += d.paid
                }
                if (d.approved > 0) {
                  sumAverageBill += parseFloat(d.total_bill_usd)
                  sumAverageBillLocal += parseFloat(d.total_bill_local)
                  sumTransit += parseInt(d.approved)
                  this.localCurrencySymbol = getSymbolFromCurrency(d.local_currency)
                }
                if (d.transit > 0) {
                  totalTransit += d.transit
                  countTransit++
                }
              })
              this.footColumns[offerId] = {
                label: {
                  value: this.$root.$t('statistic.in_total')
                },
                shipped: {
                  value: totalShipped
                },
                delivered: {
                  value: totalDelivered
                },
                transit: {
                  value: `${totalTransit} (${Helper.average(totalTransit, countTransit)})`
                },
                transitPercents: {
                  value: Helper.percents(totalShipped, totalTransit)
                },
                return: {
                  value: `${totalReturn} (${Helper.average(totalReturn, countReturn)})`
                },
                returnPercents: {
                  value: Helper.percents(totalShipped, totalReturn)
                },
                buyout: {
                  value: `${Helper.percents(totalShipped, totalDelivered - totalPaid)} (${totalDelivered - totalPaid})`
                },
                buyoutPercents: {
                  value: `${Helper.percents(totalShipped, totalDelivered)} (${totalDelivered})`
                },
                averageBill: {
                  value: Helper.averageBillDayCount(sumAverageBill, sumTransit)
                },
                averageBillLocal: {
                  value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumAverageBillLocal, sumTransit, this.localCurrencySymbol) : '-',
                  graph: filterCurrency.length === 1 ? {
                    cb: (value) => {
                      return Helper.getRawNumber(value)
                    },
                    symbol: Storage.selectedCountry.currency_symbol
                  } : false
                }
              }
            }
          })
          this.$root.$emit('data_loaded')
        }).catch(response => {
          console.log(response)
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Offer.vue?640ca566